import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
};

const IconLinkedin: React.FC<IconProps> = ({ width = 25, height = 25 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 32 32"
            fill="none"
        >
            <g clip-path="url(#clip0_6924_13351)">
                <path
                    d="M27.5121 0H4.76671C2.41135 0 0.501953 1.9094 0.501953 4.26476V27.0101C0.501953 29.3655 2.41135 31.2749 4.76671 31.2749H27.5121C29.8675 31.2749 31.7769 29.3655 31.7769 27.0101V4.26476C31.7769 1.9094 29.8675 0 27.5121 0Z"
                    fill="black"
                />
                <path
                    d="M11.7685 8.53266C11.7685 9.05984 11.6121 9.57519 11.3192 10.0135C11.0264 10.4519 10.6101 10.7935 10.123 10.9952C9.63596 11.197 9.10002 11.2498 8.58297 11.1469C8.06592 11.0441 7.59097 10.7902 7.2182 10.4174C6.84543 10.0447 6.59157 9.56972 6.48872 9.05267C6.38587 8.53562 6.43865 7.99968 6.6404 7.51263C6.84214 7.02558 7.18378 6.60929 7.62212 6.3164C8.06045 6.02351 8.57579 5.86719 9.10298 5.86719C9.8099 5.86719 10.4879 6.14801 10.9878 6.64789C11.4876 7.14776 11.7685 7.82573 11.7685 8.53266Z"
                    fill="white"
                />
                <path
                    d="M11.1629 12.9735V24.7496C11.1634 24.8365 11.1467 24.9226 11.1138 25.003C11.0808 25.0834 11.0323 25.1565 10.9711 25.2181C10.9098 25.2797 10.837 25.3285 10.7568 25.3619C10.6765 25.3953 10.5905 25.4124 10.5037 25.4124H7.69424C7.60737 25.4127 7.52131 25.3957 7.441 25.3626C7.36069 25.3294 7.28773 25.2808 7.2263 25.2193C7.16487 25.1579 7.11618 25.0849 7.08305 25.0046C7.04991 24.9243 7.03297 24.8383 7.03321 24.7514V12.9735C7.03321 12.7982 7.10285 12.6301 7.22682 12.5061C7.35079 12.3821 7.51893 12.3125 7.69424 12.3125H10.5037C10.6787 12.313 10.8463 12.3828 10.9699 12.5067C11.0935 12.6307 11.1629 12.7985 11.1629 12.9735Z"
                    fill="white"
                />
                <path
                    d="M25.8479 19.1043V24.8048C25.8482 24.8847 25.8326 24.9639 25.8021 25.0377C25.7717 25.1115 25.7269 25.1786 25.6705 25.2351C25.614 25.2916 25.5469 25.3363 25.473 25.3668C25.3992 25.3973 25.3201 25.4128 25.2402 25.4126H22.2193C22.1395 25.4128 22.0603 25.3973 21.9865 25.3668C21.9126 25.3363 21.8456 25.2916 21.7891 25.2351C21.7326 25.1786 21.6878 25.1115 21.6574 25.0377C21.6269 24.9639 21.6114 24.8847 21.6116 24.8048V19.2802C21.6116 18.4557 21.8533 15.6694 19.4561 15.6694C17.5992 15.6694 17.2207 17.5761 17.146 18.4326V24.8048C17.1461 24.9645 17.0833 25.1177 16.9712 25.2315C16.8591 25.3452 16.7068 25.4102 16.5472 25.4126H13.6294C13.5497 25.4126 13.4707 25.3968 13.3971 25.3663C13.3235 25.3357 13.2566 25.2909 13.2003 25.2345C13.144 25.178 13.0994 25.111 13.0691 25.0373C13.0387 24.9636 13.0232 24.8846 13.0234 24.8048V12.9222C13.0232 12.8424 13.0387 12.7635 13.0691 12.6897C13.0994 12.616 13.144 12.549 13.2003 12.4925C13.2566 12.4361 13.3235 12.3913 13.3971 12.3607C13.4707 12.3302 13.5497 12.3144 13.6294 12.3144H16.5472C16.7084 12.3144 16.863 12.3785 16.9769 12.4924C17.0909 12.6064 17.1549 12.761 17.1549 12.9222V13.9493C17.8444 12.9151 18.8662 12.1172 21.0465 12.1172C25.8764 12.1172 25.8479 16.6272 25.8479 19.1043Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_6924_13351">
                    <rect
                        width="31.2749"
                        height="31.2749"
                        fill="white"
                        transform="translate(0.501953)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconLinkedin;
